import Prose from '@/components/Prose';
import { fadeIn, fadeInUp } from '@/constants/motions';
import { Icon } from '@iconify/react';
import { motion } from 'framer-motion';

export default function TimelineBlock({ items }) {
  return (
    <motion.section
      className="my-16 px-4"
      initial="hidden"
      transition={{
        ...fadeIn.transition,
        delay: 0.8,
        when: 'beforeChildren',
        staggerChildren: 0.4,
      }}
      variants={fadeIn}
      viewport={fadeIn.viewport}
      whileInView="visible"
    >
      <div className="container-screen">
        {items.map(({ title, content }, i) => (
          <div key={i} className="relative flex pb-8">
            <div className="absolute inset-0 flex h-full w-10 items-center justify-center">
              <div className="pointer-events-none h-full w-1 bg-neutral-200"></div>
            </div>
            <div className="relative z-10 inline-flex h-10 w-10 flex-shrink-0 items-center justify-center rounded-full bg-primary-500 text-white">
              <Icon height="24" icon="fluent:globe-24-regular" />
            </div>
            <motion.div className="ml-4 mt-2" variants={fadeInUp}>
              <h2 className="text-xl font-medium">{title}</h2>
              <Prose className="mt-1 max-w-full">
                <p>{content}</p>
              </Prose>
            </motion.div>
          </div>
        ))}
      </div>
    </motion.section>
  );
}
